import { useCallback, useEffect, useState } from "react";
import { useContactsApi } from "../api/contactsApi";

export function useContacts() {
  const api = useContactsApi();

  const [contacts, setContacts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchContacts = useCallback(async () => {
    try {
      setLoading(true);
      const data = await api.getAll();
      setContacts(data);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, [api]);

  const addContact = async (newContact) => {
    const created = await api.create(newContact);
    setContacts((prev) => [...prev, created]);
  };

  const updateContact = async (id, updatedContact) => {
    const saved = await api.update(id, updatedContact);
    setContacts((prev) =>
      prev.map((a) => (a.id === id ? { ...a, ...saved } : a)),
    );
  };

  const deleteContact = async (id) => {
    await api.remove(id);
    setContacts((prev) => prev.filter((a) => a.id !== id));
  };

  useEffect(() => {
    fetchContacts();
  }, [fetchContacts]);

  return {
    contacts,
    loading,
    error,
    fetchContacts,
    addContact,
    updateContact,
    deleteContact,
  };
}
